import { render } from "./TheChangePassword.vue?vue&type=template&id=77c8a7e4"
import script from "./TheChangePassword.vue?vue&type=script&lang=js"
export * from "./TheChangePassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__